import { of, isNonEmpty, headNonEmpty, tailNonEmpty, prepend } from '../../Chunk/dist/effect-Chunk.esm.js';
import { Structural } from '../Data.esm.js';
import { dual } from '../../Function/dist/effect-Function.esm.js';
import { reduce, has, remove, add } from '../../HashSet/dist/effect-HashSet.esm.js';

/** @internal */
const HashSetPatchTypeId = /*#__PURE__*/Symbol.for("effect/DifferHashSetPatch");
function variance(a) {
  return a;
}

/** @internal */
const PatchProto = {
  ...Structural.prototype,
  [HashSetPatchTypeId]: {
    _Value: variance,
    _Key: variance,
    _Patch: variance
  }
};
const EmptyProto = /*#__PURE__*/Object.assign( /*#__PURE__*/Object.create(PatchProto), {
  _tag: "Empty"
});
const _empty = /*#__PURE__*/Object.create(EmptyProto);

/** @internal */
const empty = () => _empty;
const AndThenProto = /*#__PURE__*/Object.assign( /*#__PURE__*/Object.create(PatchProto), {
  _tag: "AndThen"
});

/** @internal */
const makeAndThen = (first, second) => {
  const o = Object.create(AndThenProto);
  o.first = first;
  o.second = second;
  return o;
};
const AddProto = /*#__PURE__*/Object.assign( /*#__PURE__*/Object.create(PatchProto), {
  _tag: "Add"
});

/** @internal */
const makeAdd = value => {
  const o = Object.create(AddProto);
  o.value = value;
  return o;
};
const RemoveProto = /*#__PURE__*/Object.assign( /*#__PURE__*/Object.create(PatchProto), {
  _tag: "Remove"
});

/** @internal */
const makeRemove = value => {
  const o = Object.create(RemoveProto);
  o.value = value;
  return o;
};
/** @internal */
const diff = (oldValue, newValue) => {
  const [removed, patch] = reduce([oldValue, empty()], ([set, patch], value) => {
    if (has(value)(set)) {
      return [remove(value)(set), patch];
    }
    return [set, combine(makeAdd(value))(patch)];
  })(newValue);
  return reduce(patch, (patch, value) => combine(makeRemove(value))(patch))(removed);
};

/** @internal */
const combine = /*#__PURE__*/dual(2, (self, that) => makeAndThen(self, that));

/** @internal */
const patch = /*#__PURE__*/dual(2, (self, oldValue) => {
  let set = oldValue;
  let patches = of(self);
  while (isNonEmpty(patches)) {
    const head = headNonEmpty(patches);
    const tail = tailNonEmpty(patches);
    switch (head._tag) {
      case "Empty":
        {
          patches = tail;
          break;
        }
      case "AndThen":
        {
          patches = prepend(head.first)(prepend(head.second)(tail));
          break;
        }
      case "Add":
        {
          set = add(head.value)(set);
          patches = tail;
          break;
        }
      case "Remove":
        {
          set = remove(head.value)(set);
          patches = tail;
        }
    }
  }
  return set;
});

export { HashSetPatchTypeId, combine, diff, empty, makeAdd, makeAndThen, makeRemove, patch };
